import { isAxiosError } from "axios";
import { paymentsApi } from "../httpService";


const providerService = {
    getProviders: async (query: Object = {}): Promise<any> => {
        try {
            return (await paymentsApi.get<any>("/apps/providers", {
                params: query,
            })).data;
        } catch (error: any) {
            if (isAxiosError(error)) {
                const status = error.response?.status;
                if (status && status >= 400 && status < 500) {
                    return new Promise((_, reject) => reject(error.response?.data?.errors[0].message));
                }
            }

            //throw new Error('An unexpected error occurred.');
            return new Promise((_, reject) => reject('An unexpected error occurred.'));
        }
    },


    getProvider: async (id: number | string): Promise<any> => {
        try {
            return (await paymentsApi.get<any>(`/apps/providers/${id}`)).data?.data;
        } catch (error: any) {
            if (isAxiosError(error)) {
                const status = error.response?.status;
                if (status && status >= 400 && status < 500) {
                    //throw new Error(error.response?.data?.errors[0].message);
                    return new Promise((_, reject) => reject(error.response?.data?.errors[0].message));
                }
            }

            return new Promise((_, reject) => reject('An unexpected error occurred.'));
        }
    },


    createProvider: async (data: Object): Promise<any> => {
        try {
            return (await paymentsApi.post("/apps/providers", data)).data;
        } catch (error: any) {
            if (isAxiosError(error)) {
                const status = error.response?.status;
                if (status && status >= 400) {
                    //throw new Error(error.response?.data?.errors[0].message);
                    return new Promise((_, reject) => reject(error.response?.data?.errors[0].message));
                }
            }

            return new Promise((_, reject) => reject("An unexpected Error"));
        }
    },


    updateProvider: async (id: number | string, data: Object): Promise<any> => {
        try {
            return (await paymentsApi.post(`/apps/providers/${id}`, data)).data;
        } catch (error: any) {
            if (isAxiosError(error)) {
                const status = error.response?.status;
                if (status && status >= 400) {
                    //throw new Error(error.response?.data?.errors[0].message);
                    return new Promise((_, reject) => reject(error.response?.data?.errors[0].message));
                }
            }

            return new Promise((_, reject) => reject('An unexpected error occurred.'));
        }
    },

}

export default providerService;